module.exports = __webpack_public_path__ + "media/images/challenges/sony-talent-league-edition-ii/mentors__05-c34fd1190a3342edb78cc4936cf43c8b.jpg";